var React = require('react');

function Share (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"1","y":"1","width":"22","height":"22","rx":"3","fill":"#D9D9D9","key":0}),React.createElement("path",{"d":"M13.46 10.54a3.111 3.111 0 0 0-4.4 0l-3.11 3.111a3.111 3.111 0 1 0 4.399 4.4l.857-.857m-.59-3.81a3.11 3.11 0 0 0 4.4 0l3.11-3.112a3.111 3.111 0 0 0-4.398-4.399l-.856.856","stroke":"#fff","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

Share.defaultProps = {"width":"24","height":"24","fill":"none"};

module.exports = Share;

Share.default = Share;
